import React, { useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  getBusinesAddress,
  postBusinessAddress,
} from "../../../../services/Handlers/BusinessProfileService";
import { useAuth } from "../../../../context/AuthProvider";
import { useNotification } from "../../../../context/NotificationProvider";
import BusinessAddressComponents from "../components";

export default function BusinessAddress() {
  const { userDetail } = useAuth();
  const { error, success } = useNotification();
  const [businessAddress, setBusinessAddress] = useState(null);

  const { isLoading, refetch } = useQuery(
    ["BusinessAddress", userDetail?.businessId],
    () => getBusinesAddress(userDetail?.businessId),
    {
      enabled: !!userDetail?.businessId,
      onSuccess: (res) => {
        if (res.status === 200 && res.data?.data?.address) {
          const addressData = res.data.data.address;

          setBusinessAddress({
            lat: parseFloat(addressData.latitude),
            lng: parseFloat(addressData.longitude),
            address: addressData.address,
            id: addressData.id,
            busines_id: addressData.busines_id,
            has_address: addressData.has_address,
          });

          console.log("Mapped address data:", {
            lat: parseFloat(addressData.latitude),
            lng: parseFloat(addressData.longitude),
            address: addressData.address,
          });
        }
      },
      onError: (error) => {
        console.error("Failed to fetch business address:", error);
        error("Gagal memuat alamat klinik");
      },
    }
  );

  const { mutate: saveBusinessAddress, isLoading: isSaving } = useMutation(
    (data) => postBusinessAddress(data),
    {
      onSuccess: (res) => {
        console.log("Save response:", res.data);

        if (res.status === 200 || res.status === 201) {
          success("Alamat klinik berhasil disimpan");
          refetch();
        }
      },
      onError: (error) => {
        console.error("Failed to save business address:", error);
        error("Gagal menyimpan alamat klinik");
      },
    }
  );

  const handleLocationSelect = (locationData) => {
    setBusinessAddress((prev) => ({
      ...prev,
      lat: locationData.lat,
      lng: locationData.lng,
      address: locationData.address,
    }));
  };

  const handleSubmit = () => {
    if (!userDetail?.businessId) {
      error("Business ID tidak ditemukan");
      return;
    }

    if (!businessAddress || !businessAddress.lat || !businessAddress.lng) {
      error("Silakan pilih lokasi terlebih dahulu");
      return;
    }

    if (!businessAddress.address || businessAddress.address.trim() === "") {
      error("Alamat tidak boleh kosong");
      return;
    }

    const payload = {
      business_id: parseInt(userDetail.businessId),
      address: businessAddress.address,
      latitude: businessAddress.lat,
      longitude: businessAddress.lng,
    };

    saveBusinessAddress(payload);
  };

  return (
    <BusinessAddressComponents
      businessAddress={businessAddress}
      onLocationSelect={handleLocationSelect}
      handleSubmit={handleSubmit}
      isLoading={isLoading}
      isSaving={isSaving}
    />
  );
}
